export class ConstantsStorage {
  static readonly USER_INDIKATOREN_UEBERKATEGORIE_FILTER: string =
    'USER_INDIKATOREN_UEBERKATEGORIE_FILTER';
  static readonly USER_BEGLEIT_INDIKATOR: string = 'USER_BEGLEIT_INDIKATOR';
  static readonly ERGEBNIS_STORAGE: string = 'ERGEBNIS_STORAGE';
}
